import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import statusMessages from '../../../const/status-messages';
import { statusColors } from '../../../styles/theme';
import { StyledTag } from './subcomponents';
var Status = function (_a) {
    var status = _a.status;
    var t = useTranslation().t;
    if (!status)
        return null;
    var statusColor = statusColors[status];
    return (_jsx(StyledTag, { content: t("common.".concat(status.toLowerCase(), "Status")), icon: _jsx(FontAwesomeIcon, { icon: statusMessages.get(status), color: statusColor.icon, size: "xs" }), backgroundColor: statusColor.background, textColor: statusColor.text }));
};
export default Status;
//# sourceMappingURL=index.js.map